import axios from '@axios'

export const state = {
  carriers: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allCarriers: (state) => state.carriers,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CARRIERS: (state, resp) => {
    if (!resp) return null
    state.carriers = resp.carriers
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_CARRIER: (state, carrier) => {
    state.carriers = state.carriers.filter((w) => w.id !== carrier.id)
  },
}

export const actions = {
  async getCarriers({ commit }, params = {}) {
    await axios
      .get('/api/carriers', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_CARRIERS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_CARRIERS',
          err.response.status === 404 ? { carriers: [] } : null
        )
      })
  },
  async createCarrier({ commit }, carrier) {
    return axios.post(`/api/carriers`, carrier)
  },
  async editCarrier({ commit }, carrier) {
    return axios.put(`/api/carriers`, carrier)
  },
  async deleteCarrier({ commit }, carrier) {
    await axios.delete(`/api/carriers/${carrier.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_CARRIER', carrier)
      }
    })
  },
}
